module.exports = __webpack_public_path__ + "static/img/8areaA_01.58e78d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/8areaA_01.png
// module id = 925
// module chunks = 1